import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../stores/zustand";
import authApiService from "../../services/api/AuthApiService";

const CheckoutSuccess = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { currentProduct, onboarding_completed } = useAuthStore();

  // Listen to language changes from Electron Menu
  useEffect(() => {
    if (window.electronAPI?.language) {
      const cleanup = window.electronAPI.language.onChange((newLanguage) => {
        i18n.changeLanguage(newLanguage);
      });

      return cleanup;
    }
  }, [i18n]);

  useEffect(() => {
    const handlePostCheckout = async () => {
      try {
        const flags = await authApiService.getAuthFlags();
        if (flags?.isEmailVerified && flags?.isPaid) {
          if (onboarding_completed) {
            if (currentProduct === "physio_therapist") {
              navigate("/physio-video-selection");
            } else {
              navigate("/home");
            }
          } else {
            if (currentProduct === "physio_therapist") {
              navigate("/physio-video-selection");
            } else {
              navigate("/onboarding-exercises", {
                state: { fromCheckout: true },
              });
            }
          }
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("[CheckoutSuccess] Failed to fetch flags:", error);
        navigate("/");
      }
    };

    handlePostCheckout();
  }, [navigate, currentProduct, onboarding_completed]);

  return (
    <Container component="main" maxWidth="lg" sx={{ height: "100vh" }}>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2, color: "white" }}>
          {t("verifyingCheckout")}
        </Typography>
      </Box>
    </Container>
  );
};

export default CheckoutSuccess;
